// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import TransportList from './TransportList';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(TransportList);
